import React from 'react'

export type ErrorProps = {
	property?: string
	propertyName?: string
	error?: string
	errorMessage?: string
	message?: string
}
export type ErrorListItemProps = {
	className?: string
	error: ErrorProps | string
}

const ErrorListItem = ({ className, error }: ErrorListItemProps) => {
	if (typeof error === 'string') {
		return <div className={className}>{error}</div>
	}

	return (
		<div className={className}>
			{(error.property ?? error.propertyName) && (
				<strong className="capitalize">
					{error.property ?? error.propertyName}:
				</strong>
			)}{' '}
			{error.message ?? error.error ?? error.errorMessage}
		</div>
	)
}

export default ErrorListItem
